export default __webpack_public_path__ + "static/media/our-services-social-care-children’s-learning-disability-despites.5f460a8c.jpg";